/* ═══════════════════════════════════════════════════════════════════════════════
   CLOCKWORK PREMIUM PDP — JS HELPER (v2 — social-proof counters removed)
   ─────────────────────────────────────────────────────────────────────────────
   Required companion to clockwork-premium-pdp.css.
   The theme uses a cross-origin stylesheet that locks certain class names
   (.button, .product-title, .heading-font) at fixed sizes that CSS alone
   cannot override. This script swaps those classes so our CSS takes control.

   v2 CHANGE: the fabricated "X people bought this today" / "Y people viewing"
   widgets have been removed — the numbers were randomly generated, which
   undermines trust in a science-first brand. Real social proof (verified
   reviews) should live in their place.

   HOW TO INSTALL:
   Shopify Admin → Online Store → Themes → Edit Code → Assets →
   clockwork-premium-pdp.js → replace entire contents with this file.
   ═══════════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  function upgradePDP() {
    /* ── 1. ADD TO CART BUTTON ──────────────────────────────────────────────── */
    var addSpan = document.querySelector(
      '.button-element.button-primary .button.btn-text'
    );
    if (addSpan && !addSpan.classList.contains('cw-btn')) {
      addSpan.classList.remove('button');
      addSpan.classList.add('cw-btn');
    }

    /* ── 2. BUY IT NOW BUTTON ──────────────────────────────────────────────── */
    var buyBtn = document.querySelector('.shopify-payment-button__button');
    if (buyBtn) {
      buyBtn.classList.remove('button');
      buyBtn.classList.add('cw-btn');
    }

    /* ── 3. PRODUCT BUTTONS GRID → stacked ─────────────────────────────────── */
    var prodBtns = document.querySelector('.product-buttons');
    if (prodBtns) {
      prodBtns.style.setProperty('grid-template-columns', '1fr', 'important');
      prodBtns.style.setProperty('grid-template-rows', 'auto auto', 'important');
      prodBtns.style.setProperty('gap', '8px', 'important');
    }

    /* ── 4. CROSS-SELL PRODUCT TITLES ──────────────────────────────────────── */
    var crossTitles = document.querySelectorAll(
      '.product-suggestions a.product-title'
    );
    crossTitles.forEach(function (el) {
      el.classList.remove('product-title', 'heading-font');
      el.classList.add('cw-cross-title');
    });

    /* ── 5. "PAIRS WELL WITH" HEADING ──────────────────────────────────────── */
    var heading = document.querySelector('.product-suggestion-heading');
    if (heading) {
      heading.classList.remove('heading-font');
    }

    /* ── 6. SMOOTH SWIPER CAROUSEL ─────────────────────────────────────────── */
    var swiperEl = document.querySelector('.product-media-slideshow.swiper');
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.params.speed = 650;
    }

    /* ── 7. CLEANUP: remove any social-proof counters rendered by old JS
           that may still be cached on a visitor's browser ─────────────────── */
    document
      .querySelectorAll('.cw-social-proof, .cw-viewing-proof')
      .forEach(function (el) {
        el.remove();
      });
  }

  /* Run on DOMContentLoaded or immediately if already loaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      /* Small delay to ensure Shopify's own JS has initialized */
      setTimeout(upgradePDP, 100);
    });
  } else {
    setTimeout(upgradePDP, 100);
  }

  /* Re-run after Shopify AJAX cart updates (cross-sell may re-render) */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.addedNodes.length) {
        var needsUpdate = false;
        m.addedNodes.forEach(function (n) {
          if (
            n.nodeType === 1 &&
            (n.classList.contains('product-title') ||
              n.querySelector('.product-title') ||
              n.classList.contains('btn-text') ||
              n.querySelector('.btn-text') ||
              n.classList.contains('cw-social-proof') ||
              n.classList.contains('cw-viewing-proof'))
          ) {
            needsUpdate = true;
          }
        });
        if (needsUpdate) setTimeout(upgradePDP, 50);
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();